<div *ngLet="langChange$ | async" [style.min-height]="'600px'">
  <div class="table-container header">
    <div class="table-hider" (click)="changeSorting(nameSorting)">
      <div class="h3-impaired-dark">
        {{ 'VERSION_VISUALLY_IMPAIRED.NAME' | translate }}
      </div>
      <app-impaired-icon
        *ngIf="sorting.type === nameSorting"
        [invertColor]="true"
        [iconName]="sorting.value === 'ASC' ? icons.ImpairedDown : icons.ImpairedUp"
      ></app-impaired-icon>
    </div>

    <div class="table-hider" (click)="changeSorting(categorySorting)">
      <div class="h3-impaired-dark">
        {{ 'VERSION_VISUALLY_IMPAIRED.CATEGORY' | translate }}
      </div>
      <app-impaired-icon
        *ngIf="sorting.type === categorySorting"
        [invertColor]="true"
        [iconName]="sorting.value === 'ASC' ? icons.ImpairedDown : icons.ImpairedUp"
      ></app-impaired-icon>
    </div>

    <div class="table-hider" (click)="changeSorting(provideSorting)">
      <div class="h3-impaired-dark">
        {{ 'VERSION_VISUALLY_IMPAIRED.PROVIDER' | translate }}
      </div>
      <app-impaired-icon
        *ngIf="sorting.type === provideSorting"
        [invertColor]="true"
        [iconName]="sorting.value === 'ASC' ? icons.ImpairedDown : icons.ImpairedUp"
      ></app-impaired-icon>
    </div>
  </div>
  <div (click)="openCatalog($event.target, catalog)" class="table-container row" *ngFor="let catalog of catalogs">
    <div class="body1-impaired">
      {{ isRuLocale ? catalog.name : catalog.nameEn || catalog.name }}
    </div>

    <div class="body1-impaired">{{ isRuLocale ? catalog.categoryName : catalog.categoryNameEn || catalog.categoryName }}</div>
    <div class="body1-impaired">{{ isRuLocale ? catalog.providerName : catalog.providerNameEn || catalog.providerName }}</div>
    <div class="option-container">
      <div class="status_block">
        <div class="status-container" *ngIf="catalog.hasGeo && isRuLocale">
          <span class="body3-impaired-dark">{{ 'OTHER.GOT_A_MAP' | translate }}</span>
        </div>
        <div class="status-container" *ngIf="catalog.archive">
          <span class="body3-impaired-dark">{{ 'OTHER.ARCHIVE' | translate }}</span>
        </div>

        <div class="status-container" *ngIf="catalog.isDynamic">
          <span class="body3-impaired-dark">{{ 'DATA.TABLE_FILTER.DYNAMIC' | translate }}</span>
        </div>
      </div>

      <app-download-button
        (changedMenuOpen)="buttonIconComponent.isActive = $event"
        [isImpairedVersion]="true"
        [catalogId]="catalog.id"
        [isDynamic]="catalog.isDynamic"
      >
        <app-button-icon
          #buttonIconComponent
          [iconName]="buttonIconComponent.isActive ? icons.Close : icons.BigTriangleDown"
          [classSize]="'medium-impaired'"
          [buttonName]="'DATA.TABLE.EXPORT' | translate"
        ></app-button-icon>
      </app-download-button>
    </div>
  </div>
</div>
